<template>
  <div>
    <div class="home_head">
      <div class="hombody_text">
        <div class="hombody_text1">文华<common-data name="appFullName_TMS"/>是一款为私募、产业、期货公司资管部、风险子公司、公募等投资机构/团队打造的，服务于机构的管理人员、风控人员、基金经理、投资顾问、交易员等各个工作岗位，涵盖自由组合交易通道下单、多账户管理、资金管理、风险监控、资产分析等功能为一体的交易管理系统。</div>
        <div class="hombody_text2">
          <div><span>应用场景一：</span><span><router-link to="/sence">私募/团队的业务管理</router-link></span></div>
          <div><span>应用场景二：</span><span><router-link to="/sence">期货公司资管部门的业务管理</router-link></span></div>
        </div>
      </div>
    </div>
    <!-- <img src="../assets/img/banner_02.jpg" alt="" class="ban"> -->
    <div class="home_body">
      <div class="home_body_text">
        <img
          src="../assets/img/WJG-00.png"
          alt=""
          class="form"
          @click="checkform"
        />
        <!-- 文华TMS交易管理系统是一款专为金融投资机构打造的，以多交易通道为核心，服务于机构的管理人员、风控人员、基金经理、交易员等各个工作岗位，涵盖自由组合交易通道下单、账户管理、资金管理、风险监控、资产分析等功能为一体的交易管理系统。 -->
      </div>
      <div style="color:#686667;font-size:19px;text-align:left;width:991px;margin:14px auto">TMS系统功能架构图</div>
      <div style="min-height: 564px" class="home_body_middle"></div>
      <!-- <div class="home_body_lj">
        <div class="zg" @click="goto(1)">
          <img src="../assets/img/ziguan.png" alt="" />交易管理端
        </div>
        <div class="gw" @click="goto(2)">
          <img src="../assets/img/geren.png" alt="" />客户端
        </div>
      </div> -->
    </div>
    <formss v-if="showform" @callback="callback" ref="fs"></formss>
  </div>
</template>
<script>
// import axios from "axios";
import formss from "../components/formss.vue";
export default {
  data() {
    return {
      showform: false,
    };
  },
  methods: {
    goto(id) {
      var newpage = this.$router.resolve({ path: `/feature?fe=${id}` });
      window.open(newpage.href, "_blank"); //单页面跳转路由锚点并打开新页面
    },
    callback(bool) {
      this.showform = bool;
    },
    checkform() {
      this.showform = true;
    },
  },
  components: {
    formss,
  },
  created() {
    this.showform=Boolean(this.$route.query.check)
    //     axios.post('https://wh9.wenhua.com.cn/api/AddApi/AddWh9Apply',{
    //       'plat': 0,
    //       'type':2,
    // 'city': '北京',
    // 'company': '文华测试',
    // 'applyname': '马浩然',
    // 'tel': 13604897465,
    // 'address': '地址',
    //     }).then((res)=>{
    // console.log(res)
    //     }).catch((err)=>{
    // console.log(err)
    //     })
  },
};
</script>
<style scoped>
.home_head {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=73) no-repeat center;
  height: 396px;
  position: relative;
  /* image-rendering: pixelated; */
  /* width: 1920px;
  margin: 0 auto; */
}
.home_head img {
  /* position: absolute; */
}
.home_head1 {
  /* left: 467px;
top: 151px; */
  float: left;
  margin: 151px 0 0 467px;
}
.hombody_text{
  width: 1060px;
  padding-top: 135px;
  margin: 0 auto;
  font-size: 15px;
  text-align: justify;
}
.hombody_text1{
  text-indent: 2em;
  color: #5e5e5e;
  width: 510px;
}
.hombody_text2{
  text-indent: 0em;
  line-height: 30px;
  margin-top: 20px;
}
.hombody_text2 span:first-child{
  color:#4446a3 ;
}
.hombody_text2 span:last-child{
  color:#6380b2 ;
  text-decoration: underline;
  cursor: pointer;
}
.home_head2 {
  position: absolute;
  bottom: -24px;
  left: 942px;
}
.ban {
}
.home_body {
  height: 720px;
  background: url(../assets/img/bg.jpg) no-repeat center;
}
.home_body_text {
  width: 935px;
  padding-top: 55px;
  margin: 0 auto;
  color: #656565;
  font-size: 16px;
  text-align: left;
  text-indent: 2em;
  line-height: 28px;
  position: relative;
}
.home_body_lj {
  padding-top: 18px;
  width: 1215px;
  margin: 0 auto;
}
.zg {
  width: 582px;
  height: 119px;
  background: url(../assets/img/l-xb.png) no-repeat center;
  margin-right: 40px;
  float: left;
  line-height: 119px;
  color: #e4c8b2;
  font-size: 20px;
  letter-spacing: 2px;
  cursor: pointer;
}
.gw {
  width: 582px;
  height: 119px;
  background: url(../assets/img/r-xb.png) no-repeat center;
  float: left;
  line-height: 119px;
  color: #e4c8b2;
  font-size: 20px;
  letter-spacing: 2px;
  cursor: pointer;
}
.zg img,
.gw img {
  margin-right: 10px;
  vertical-align: middle;
}
.zg:hover,
.gw:hover {
  opacity: 0.8;
}
.home_body_middle {
  background: url(../assets/img/home-04.png) no-repeat center;
  margin: 0px 0 44px 0;
}
.form {
  position: absolute;
  top: -50px;
  left: -233px;
  cursor: pointer;
}
.hombody_text2 a:visited{
  color:#6380b2 ;
}
</style>